import React from "react";
import { Typography } from "@mui/material";
import { PromoCode as PromoCodeType } from "@/types/dto/common/dynamic-cta";

interface PromoCodeProps extends PromoCodeType {
  testId?: string;
}

const PromoCode: React.FC<PromoCodeProps> = ({ promoCodeLabel, promoCode, testId = "promo-code" }) => (
  <Typography
    color="text.primary"
    component="p"
    variant="h5"
    data-testid={testId}
    data-track="click"
    tabIndex={0}
    sx={{
      display: "flex",
      padding: "2rem 3rem",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "1rem",
      border: "1px dashed",
      borderColor: "text.primary",
      gap: "1rem"
    }}
  >
    {`${promoCodeLabel}: ${promoCode}`}
  </Typography>
);

export default PromoCode;